'use client';

import { usePageDataContextOptional } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { Breadcrumb } from '$/components/cms/components-internal/Breadcrumb';

/**
 * The page's breadcrumb trail as every hero variant renders it. Renders
 * nothing without page data (a host outside a page provider). `darkmode`
 * paints it for a Dark hero background (CMS-2081).
 */
export const FlexibleHeroBlockBreadcrumb = ({
  darkmode,
}: {
  darkmode?: boolean;
}) => {
  const { pageData, pageType } = usePageDataContextOptional() ?? {};
  const page = pageData?.page;

  if (!page || !pageType) {
    return null;
  }

  return (
    <div
      className="mhg-alpha-typography-breadcrumb w-full text-left"
      data-component="flexible-hero-block-breadcrumb"
    >
      <Breadcrumb
        darkmode={darkmode}
        pageType={pageType}
        pageTitle={page.title}
        pageSlug={page.slug}
        vertical={page.section}
        urlPrefix={page.urlPrefix}
        isBlogLanding={'blogLanding' in page && !!page.blogLanding}
        isBlogVerticalLanding={
          'blogVerticalLanding' in page && !!page.blogVerticalLanding
        }
        isHomepage={'is_homepage' in page && page.is_homepage}
        isVerticalLanding={
          'is_vertical_landing' in page && page.is_vertical_landing
        }
      />
    </div>
  );
};
